import { css } from '@emotion/react'
import { useState } from 'react'
import type { OnChangeEventContext } from '../../../shared/input/Dropdown'

import { ConfirmModal } from '../../../shared/modal/ConfirmModal/ConfirmModal'
import { Select } from '../../../shared/input'
import { PlanOption } from '../../../../types'

const autoContainerCss = css`
  position: relative;
  padding-top: 20px;
  margin-left: -8px;
`

type ConfirmReplacePrimaryModalProps = {
  /** The text for the modal body */
  bodyText?: string
  /** The text of the confirm button */
  confirmText?: string
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when modal is closed (Escape, Cancel, or X button) - A11Y-535: Required for focus restoration */
  onClose?: () => void
  /** Event callback when Confirm Button is triggered */
  onConfirm: (id: string) => void
  /** The list of the user's plans to be displayed in the dropdown */
  planOptions: PlanOption[]
  /** The title of the modal */
  title?: string
}

export const ConfirmReplacePrimaryModal = ({
  bodyText = 'Choose another plan as your primary plan:',
  confirmText = 'Ok',
  isOpen,
  onClose = () => {},
  onConfirm,
  planOptions,
  title = 'Remove as Primary Plan'
}: ConfirmReplacePrimaryModalProps) => {
  const [inputValue, setInputValue] = useState<PlanOption | undefined>(undefined)

  const onChangeEvent = (e: OnChangeEventContext) => {
    setInputValue(e.value as PlanOption)
  }

  const onConfirmModal = () => {
    if (inputValue && inputValue.id) {
      onConfirm(inputValue.id)
    }
  }

  return (
    <ConfirmModal
      confirmText={confirmText}
      confirmButtonDisabled={!inputValue || inputValue.id.length === 0}
      isOpen={isOpen}
      onClose={onClose!}
      onConfirm={onConfirmModal}
      title={title!}
    >
      {bodyText}
      <div css={autoContainerCss}>
        <Select
          aria-label="Select a new Plan"
          id="plan"
          label="Select a new Plan"
          labelKey="label"
          name="plan"
          onChange={onChangeEvent}
          options={planOptions}
          value={inputValue && inputValue}
          valueKey="id"
        />
      </div>
    </ConfirmModal>
  )
}

export default ConfirmReplacePrimaryModal
